// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_m3m","cls2":"AppsMegaMenu-cls2_f1n AppsMegaMenu-cls1_m3m"};